package com.ucasoft.komm.website.pages.plugins

val pluginData = listOf(
    iterablePlugin,
    exposedPlugin,
    enumPlugin
)